module.exports = __webpack_public_path__ + "static/cycling-1c2a986ec131679032870bb8beb466f6.jpg";